import classNames from 'classnames'
import { Row, Space, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import keys from '@/config/keys'

export const LoadingIndicator = LoadingOutlined

export default function Loading({ size, msg, msgColor, style = {}, component, className }) {
	return (
		<div className={classNames('flex-center w-full animate-fade animate-delay-100', className)}>
			<Space direction='vertical' style={{ ...style }}>
				{component ? (
					<Row justify='center' align='middle' className='min-h-[50px]'>
						{component}
					</Row>
				) : (
					<Row justify='center'>
						<Spin size={size} />
					</Row>
				)}

				{msg && (
					<p
						className='m-0 mx-2.5 text-center text-[15px] font-bold opacity-80'
						style={{ color: msgColor || 'var(--primary-color)' }}
					>
						{msg}
					</p>
				)}
			</Space>
		</div>
	)
}

export const renderLoading = ({
	size = 48,
	tip = '',
	className = 'w-full h-full',
	fade = true,
} = {}) => {
	return (
		<div
			className={classNames(
				'flex-center',
				keys.LOADING_INDICATOR_CLASS,
				{ 'animate-fade animate-delay-100': fade },
				className,
			)}
		>
			<Space direction='vertical' align='center'>
				<Spin
					indicator={
						<LoadingIndicator
							spin
							className={keys.LOADING_INDICATOR_ICON_CLASS}
							style={{ fontSize: typeof size === 'number' ? size : undefined }}
						/>
					}
					size={typeof size === 'string' ? size : undefined}
				/>

				{tip ? (
					<p className='!m-0 text-center text-sm font-medium'>{tip}</p>
				) : (
					<div className='w-full' />
				)}
			</Space>
		</div>
	)
}
